// src/components/Recomendacoes/PerfilForm.js
import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Typography,
  Autocomplete,
} from '@mui/material';

export default function PerfilForm({ onSubmit, initialData = {} }) {
  const [formData, setFormData] = React.useState({
    tipoEnsinoMedio: initialData.tipoEnsinoMedio || '',
    mediasNotas: initialData.mediasNotas?.media || '',
    areasDestaque: initialData.areasDestaque || [],
    localizacao: initialData.localizacao || ''
  });

  const areas = [
    'Matemática',
    'Física',
    'Química',
    'Biologia',
    'Geografia',
    'História',
    'Português',
    'Inglês'
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 600, mx: 'auto' }}>
      <Typography variant="h6" gutterBottom>
        Complete seu Perfil Acadêmico
      </Typography>

      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Tipo de Ensino Médio</InputLabel>
        <Select
          value={formData.tipoEnsinoMedio}
          onChange={(e) => setFormData(prev => ({ 
            ...prev, 
            tipoEnsinoMedio: e.target.value 
          }))}
          required
        >
          <MenuItem value="ciencias">Ciências</MenuItem>
          <MenuItem value="letras">Letras</MenuItem>
          <MenuItem value="tecnico">Técnico</MenuItem>
        </Select>
      </FormControl>

      <TextField
        fullWidth
        label="Média de Notas"
        type="number"
        inputProps={{ step: "0.1", min: "0", max: "10" }}
        value={formData.mediasNotas}
        onChange={(e) => setFormData(prev => ({ 
          ...prev, 
          mediasNotas: e.target.value 
        }))}
        sx={{ mb: 2 }}
        required
      />

      <FormControl fullWidth sx={{ mb: 2 }}>
        <Autocomplete
          multiple
          options={areas}
          value={formData.areasDestaque}
          onChange={(_, newValue) => setFormData(prev => ({
            ...prev,
            areasDestaque: newValue
          }))}
          renderInput={(params) => (
            <TextField {...params} label="Áreas de Destaque" />
          )}
        />
      </FormControl>

      <TextField
        fullWidth
        label="Localização"
        value={formData.localizacao}
        onChange={(e) => setFormData(prev => ({ 
          ...prev, 
          localizacao: e.target.value 
        }))}
        sx={{ mb: 3 }}
        required
      />

      <Button 
        type="submit" 
        variant="contained" 
        fullWidth
        size="large"
      >
        Salvar Perfil
      </Button>
    </Box>
  );
}

// Adicionando validações de tipo para as props
PerfilForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialData: PropTypes.shape({
    tipoEnsinoMedio: PropTypes.string,
    mediasNotas: PropTypes.shape({
      media: PropTypes.string,
    }),
    areasDestaque: PropTypes.arrayOf(PropTypes.string),
    localizacao: PropTypes.string,
  }),
};
